module.exports = __webpack_public_path__ + "img/rekayasa-perangkat-lunak.f6cfb465.png";